import {take, call, put, select} from 'redux-saga/effects'
import * as Excel from "exceljs/dist/exceljs.min.js";
import {
  SENDING_CHART_DEVICE_DATA_REQUEST,
  FETCH_CHART_DEVICE_DATA_REQUEST,
  FETCH_CHART_DEVICE_DATA_SUCCESS,
  FETCH_CHART_DEVICE_DATA_FAILURE,

  SENDING_TIME_LINE_DEVICE_DATA_REQUEST,
  FETCH_TIME_LINE_DEVICE_DATA_REQUEST,
  FETCH_TIME_LINE_DEVICE_DATA_SUCCESS,
  FETCH_TIME_LINE_DEVICE_DATA_FAILURE,

  SENDING_POWER_METER_DAY_DATA_REQUEST,
  FETCH_POWER_METER_DAY_DATA_REQUEST,
  FETCH_POWER_METER_DAY_DATA_SUCCESS,
  FETCH_POWER_METER_DAY_DATA_FAILURE,

  SENDING_POWER_METER_MONTH_DATA_REQUEST,
  FETCH_POWER_METER_MONTH_DATA_REQUEST,
  FETCH_POWER_METER_MONTH_DATA_SUCCESS,
  FETCH_POWER_METER_MONTH_DATA_FAILURE,
  EXPORT_DEVICE_DATA_REQUEST,
  EXPORT_DEVICE_DATA_FAILURE
} from '../actions/constants'
import {
  SUB_CATEGORY_TEMPERATURE,
  SUB_CATEGORY_TEMPERATURE_OUTSIDE,
  SUB_CATEGORY_HUMIDITY,
  SUB_CATEGORY_HUMIDITY_OUTSIDE,
  SUB_CATEGORY_LUMINARY,
  SUB_CATEGORY_V_AC_METER,
  SUB_CATEGORY_POWER_METER,
  SUB_CATEGORY_POWER_METER_DAY,
  SUB_CATEGORY_POWER_METER_MONTH
} from '../constants/defaultValues'

import chart from '../api/chart'
import deviceApi from '../api/device'
import {putNotify} from './utils'

const getTokenFromState = (state) => state.user.currentUser.token;
const getSystemIDFromState = (state) => state.system.currentSystem.ID;
const getStationIDFromState = (state) => state.station.currentStation.ID;
const getStationFromState = (state) => state.station.currentStation;
const getPowerChartDataFromState = (state) => state.chart.powerChartData;
const getAINChartDataFromState = (state) => state.chart.ainChartData;
const getDINChartDataFromState = (state) => state.chart.dinChartData;

function* fetchChartDeviceData(token, systemID, stationID, deviceID, from, to, offset, limit) {
  yield put({type: SENDING_CHART_DEVICE_DATA_REQUEST, sending: true})
  try {
    return yield call(chart.fetchChartDeviceData, token, systemID, stationID, deviceID, from, to, offset, limit)
  } catch (error) {
    yield put({type: FETCH_CHART_DEVICE_DATA_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_CHART_DEVICE_DATA_REQUEST, sending: false})
  }
}

export function* watchFetchChartDeviceData() {
  while (true) {
    const {device, from, to, offset, limit} = yield take(FETCH_CHART_DEVICE_DATA_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const stationID = yield select(getStationIDFromState);
    const response = yield call(fetchChartDeviceData, token, systemID, stationID, device.DeviceId, from, to, offset, limit)
    const arr = yield call(putNotify, {response})
    const ainDatas = Array.isArray(arr)
      ? arr
      : []
    yield put({type: FETCH_CHART_DEVICE_DATA_SUCCESS, chartAIN: ainDatas})
  }
}

function* fetchTimeLineDeviceData(token, systemID, stationID, deviceID, from, to, offset, limit) {
  yield put({type: SENDING_TIME_LINE_DEVICE_DATA_REQUEST, sending: true})
  try {
    return yield call(chart.fetchTimeLineDeviceData, token, systemID, stationID, deviceID, from, to, offset, limit)
  } catch (error) {
    yield put({type: FETCH_TIME_LINE_DEVICE_DATA_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_TIME_LINE_DEVICE_DATA_REQUEST, sending: false})
  }
}

export function* watchFetchTimeLineDeviceData() {
  while (true) {
    const {device, from, to, offset, limit} = yield take(FETCH_TIME_LINE_DEVICE_DATA_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const stationID = yield select(getStationIDFromState);
    const response = yield call(fetchTimeLineDeviceData, token, systemID, stationID, device.DeviceId, from, to, offset, limit)
    const arr = yield call(putNotify, {response})
    const dinDatas = Array.isArray(arr)
      ? arr
      : []
    const reduceDevices = arr.map((item) => {
      return {
        ...item,
        DeviceId: device.DeviceId,
        SubCategory: device.SubCategory
      }
    })
    const stateDevices = yield call(deviceApi.reduceStateDevices, {reduceDevices})
    yield put({type: FETCH_TIME_LINE_DEVICE_DATA_SUCCESS, chartDIN: stateDevices})
  }
}

function* fetchChartPowerMeterDayData(token, systemID, stationID, deviceID, from, to, offset, limit) {
  yield put({type: SENDING_POWER_METER_DAY_DATA_REQUEST, sending: true})
  try {
    return yield call(chart.fetchChartPowerMeterDayData, token, systemID, stationID, deviceID, from, to, offset, limit)
  } catch (e) {
    yield put({type: FETCH_POWER_METER_DAY_DATA_FAILURE, error: e.message})
    return e
  } finally {
    yield put({type: SENDING_POWER_METER_DAY_DATA_REQUEST, sending: false})
  }
}

export function* watchFetchChartPowerMeterDayData() {
  while (true) {
    const {device, from, to, offset, limit} = yield take(FETCH_POWER_METER_DAY_DATA_REQUEST)
    const token = yield select(getTokenFromState)
    const systemID = yield select(getSystemIDFromState)
    const stationID = yield select(getStationIDFromState)
    const response = yield call(fetchChartPowerMeterDayData, token, systemID, stationID, device.DeviceId, from, to, offset, limit);
    const arr = yield call(putNotify, {response})
    const powerDay = Array.isArray(arr)
      ? arr
      : []
    yield put({type: FETCH_POWER_METER_DAY_DATA_SUCCESS, charPowerDay: powerDay})
  }
}

function* fetchChartPowerMeterMonthData(token, systemID, stationID, deviceID, from, to, offset, limit) {
  yield put({type: SENDING_POWER_METER_MONTH_DATA_REQUEST, sending: true})
  try {
    return yield call(chart.fetchChartPowerMeterMonthData, token, systemID, stationID, deviceID, from, to, offset, limit)
  } catch (e) {
    yield put({type: FETCH_POWER_METER_MONTH_DATA_FAILURE, error: e.message})
    return e
  } finally {
    yield put({type: SENDING_POWER_METER_MONTH_DATA_REQUEST, sending: false})
  }
}

export function* watchFetchChartPowerMeterMonthData() {
  while (true) {
    const {device, from, to, offset, limit} = yield take(FETCH_POWER_METER_MONTH_DATA_REQUEST)
    const token = yield select(getTokenFromState)
    const systemID = yield select(getSystemIDFromState)
    const stationID = yield select(getStationIDFromState)
    const response = yield call(fetchChartPowerMeterMonthData, token, systemID, stationID, device.DeviceId, from, to, offset, limit);
    const arr = yield call(putNotify, {response})
    const powerMonth = Array.isArray(arr)
      ? arr
      : []
    yield put({type: FETCH_POWER_METER_MONTH_DATA_SUCCESS, chartPowerMonth: powerMonth})
  }
}

export function* watchExportDeviceData() {
  while (true) {
    const {device, timeQuery, from, to} = yield take(EXPORT_DEVICE_DATA_REQUEST)
    try {
      let workbook = new Excel.Workbook();
      let worksheet = workbook.addWorksheet('Sheet 1');
      const station = yield select(getStationFromState)
      const filename = `${device.Name} ${station.Name} từ ${from} đến ${to}.xlsx`
      if (device.SubCategory === SUB_CATEGORY_POWER_METER_DAY || device.SubCategory === SUB_CATEGORY_POWER_METER_MONTH) {
        worksheet.columns = [
          {
            header: 'Thời gian',
            key: 'time',
            width: 50
          }, {
            header: 'Giá trị',
            key: 'value',
            width: 30
          }
        ];
        const datas = yield select(getPowerChartDataFromState)
        datas.forEach((item) => {
          worksheet.addRow({time: item.Time, value: item.Value})
        })
      } else if (device.SubCategory === SUB_CATEGORY_TEMPERATURE || device.SubCategory === SUB_CATEGORY_TEMPERATURE_OUTSIDE || device.SubCategory === SUB_CATEGORY_HUMIDITY || device.SubCategory === SUB_CATEGORY_HUMIDITY_OUTSIDE || device.SubCategory === SUB_CATEGORY_LUMINARY || device.SubCategory === SUB_CATEGORY_V_AC_METER || device.SubCategory === SUB_CATEGORY_POWER_METER) {
        worksheet.columns = [
          {
            header: 'Thời gian',
            key: 'time',
            width: 50
          }, {
            header: 'Giá trị',
            key: 'value',
            width: 30
          }
        ];
        const datas = yield select(getAINChartDataFromState)
        datas.forEach((item) => {
          worksheet.addRow({time: item.Time, value: item.Value})
        })
      } else {
        worksheet.columns = [
          {
            header: 'Thời gian',
            key: 'time',
            width: 50
          }, {
            header: 'Trạng thái',
            key: 'state',
            width: 30
          }
        ];
        const datas = yield select(getDINChartDataFromState)
        datas.forEach((item) => {
          worksheet.addRow({time: item.Time, state: item.Text})
        })
      }

      workbook.xlsx.writeBuffer({base64: true}).then(function(xls64) {
        // build anchor tag and attach file (works in chrome)
        let a = document.createElement("a");
        const data = new Blob([xls64], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});

        const url = URL.createObjectURL(data);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 0);
      })
    } catch (err) {
      yield put({type: EXPORT_DEVICE_DATA_FAILURE, error: err.message})
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/chart.js